const $window = $(window);
const breakPoint = 767;
const heightChange = 50;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();
//const bodyLimitHeight = (windowHeight - 185) * 0.88;

let url = location.href;

// preload
const preload = () =>{
  let timer = 0;
  $(window).on('load' , function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $("body").removeClass("preload");
    }, 100);
  });
};

// resizing
const resizing = () =>{
  let timer = 0;
  $(window).on('resize' , function() {
    $('.header-menu').css('transition','none')
    $('.header-menu a').css('transition','color .3s')
    $('header .logo').css('transition','opacity .3s')
    let resizeWidth = $window.width();
    if(windowWidth !== resizeWidth){
      $("body").addClass("resizing");
      if (timer > 0) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        $("body").removeClass("resizing");
      }, 100);
    }
    windowWidth = resizeWidth;
  });
};

//ページ内リンクのアニメーション
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top;
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
};
// ------------------------------------------------------------------------
// headerScroll
// ------------------------------------------------------------------------
//headerScroll
 const headerScroll = () => {
     $(window).on('scroll', function(){
       $('.header-menu a').css('transition','margin .3s,color .3s')
       $('header .logo').css('transition','margin .3s,opacity .3s')
       if($(window).scrollTop()>heightChange){
         $('header').addClass('smaller');
       }else if($('header').hasClass('smaller')){
         $('header').removeClass('smaller');
       }
     });
 }

// ------------------------------------------------------------------------
// headerToggle
// ------------------------------------------------------------------------
//headerToggle
const headerToggle = () => {
  $('header .hamburger,header .cross').on('click', function () {
    //追加
    $('.header-menu').css('transition','transform .3s')
    //ここまで
		$('.header-menu').toggleClass('opened')
	});
};
// ------------------------------------------------------------------------
// pageTop
// ------------------------------------------------------------------------

//ページTOP
const pageTop = () => {


  $(window).on("scroll", function(){
    var scrollPosition = $(window).scrollTop();
    // if(windowW >= 768){
      if(scrollPosition >= 50){
        $(".sw-Top").removeClass('sw-Top-Hidden');
      } else {
        $(".sw-Top").addClass('sw-Top-Hidden');
      }
    // }
  });

  $("#st-Top,#footer-top").on("click", function(){
    var linkSpeed    = 500;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutQuint");
    return false;
  });

};

// ------------------------------------------------------------------------
// faqToggle
// ------------------------------------------------------------------------
//faqToggle
const faqToggle = () => {
  $('.faq_List .faq_List_Item dl dt').on('click', function () {
		$(this).next('dd').slideToggle(250).css('display', 'block');
		$(this).parent().toggleClass('opened')
	});
};
// ------------------------------------------------------------------------
// formCheck
// ------------------------------------------------------------------------
//formCheck
const formCheck = () => {
  $('#check').on('click', function () {
		$(this).toggleClass('checked')
    $('.send').toggleClass('ready');
	});
};

//export
export {preload, resizing, anchorScroll, pageTop, headerToggle, faqToggle, formCheck, headerScroll};



// WEBPACK FOOTER //
// ./src/sc-ins/assets/js/include/module.js